<span class="inline-block w-full text-primary text-sm" [class]="cssClass" *ngIf="condition">
  {{ errorMessage ? (errorMessage | translate) : translatedErrorMessage }}
</span>
